// @ts-check

/** @file Native-safe construction for generated local SQLite model accessors. */

import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Builds a local model shell without a transformed intermediate subclass.
 * Expo's native class transform hard-codes each intermediate superclass and
 * loses an operation Proxy's `new.target`; one explicit Reflect construction
 * hop preserves Velocious's public operation-bound model metadata on Hermes.
 * @template {typeof DatabaseRecord} MC Generated base class type.
 * @param {MC} GeneratedBase Generated accessor base.
 * @returns {MC} Local model class with generated instance accessors.
 * @throws {Error} When the generated class name does not identify a base.
 */
export default function localDatabaseModel(GeneratedBase) {
  const modelName = GeneratedBase.name.replace(/Base$/u, "")
  if (!modelName || modelName === GeneratedBase.name) throw new Error("Local database generated model name must end in Base")

  /**
   * Preserves an operation-bound Proxy as DatabaseRecord's new.target without
   * asking the native class transform to lower another derived constructor.
   * @param {Record<string, unknown>} [changes] Initial attributes.
   * @returns {DatabaseRecord} Operation-bound local record.
   * @throws {TypeError} When called without construction semantics.
   */
  function LocalDatabaseModel(changes = {}) {
    if (!new.target) throw new TypeError(`${modelName} must be constructed with new`)
    return Reflect.construct(DatabaseRecord, [changes], new.target)
  }

  Object.setPrototypeOf(LocalDatabaseModel, DatabaseRecord)
  Object.setPrototypeOf(LocalDatabaseModel.prototype, DatabaseRecord.prototype)
  Object.defineProperties(LocalDatabaseModel.prototype, generatedAccessorDescriptors(GeneratedBase))
  Object.defineProperty(LocalDatabaseModel, "modelName", {value: modelName})
  Object.defineProperty(LocalDatabaseModel, "name", {configurable: true, value: modelName})

  return /** @type {MC} */ (/** @type {unknown} */ (LocalDatabaseModel))
}

/**
 * Copies only generated instance accessors; DatabaseRecord owns construction
 * and operation-aware model-class lookup.
 * @param {typeof DatabaseRecord} GeneratedBase Generated model base.
 * @returns {object} Descriptors without construction or model lookup overrides.
 */
function generatedAccessorDescriptors(GeneratedBase) {
  const descriptors = Object.getOwnPropertyDescriptors(GeneratedBase.prototype)
  delete descriptors.constructor
  delete descriptors.getModelClass
  return descriptors
}
